/**
 * Application-wide constants
 * Single source of truth for shared values used across components.
 */

// Predefined use cases for content generation
export const PREDEFINED_USE_CASES = [
  "NUS Bulleting",
  "Computing@NUS",
  "Email",
  "Announcement",
  "Linkedin Post",
];

// localStorage keys
export const STORAGE_KEYS = {
  CUSTOM_PROMPTS: "customPrompts",
  THEME: "theme",
  CUSTOM_USE_CASES: "selenedocs_custom_use_cases",
};

// Prompt categories used by App.jsx and PromptEditor
export const PROMPT_CATEGORY_KEYS = [
  "summarization",
  "postprocessing",
  "enhancement",
  "feedback",
  "metadata",
  "editing",
  "use_case",
  "other",
];

export const PROMPT_CATEGORY_LABELS = {
  summarization: "Summarization",
  postprocessing: "Post-Processing",
  enhancement: "Enhancement",
  feedback: "Feedback",
  metadata: "Metadata",
  editing: "Editing",
  use_case: "Use Case",
  other: "Other",
};
